import {Action} from '@ngrx/store';
import {type} from '../../shared';
import {Contract, ContractForm} from '../models/contract';
import {LanguageText, LanguageTextForm} from '../models/language-text';


export const languageTextsUpdateActionTypes = {
  UPDATE: type('[Language Texts] Update'),
  UPDATE_SUCCESS: type('[Language Texts] Update Success'),
  UPDATE_FAIL: type('[Language Texts] Update Fail'),
};

export class LanguageTextsUpdateAction implements Action {
  readonly type = languageTextsUpdateActionTypes.UPDATE;
  constructor(public payload?: LanguageTextForm[]) {}
}

export class LanguageTextsUpdateSuccessAction implements Action {
  readonly type = languageTextsUpdateActionTypes.UPDATE_SUCCESS;
  constructor(public payload?: LanguageText[]) {}
}

export class LanguageTextsUpdateFailAction implements Action {
  readonly type = languageTextsUpdateActionTypes.UPDATE_FAIL;
  constructor(public payload?: string) {}
}


